import React, { useEffect, useState } from 'react';
import {
  applicationsByMunicipality,
  applicationsByStatus,
  applicationsByBusiness,
  applicationsByJob,
  applicationsByGender,
  applicationsByAge,
  applicationsByEthnicity,
  applicationsByHealthCondition,
  applicationsByCategory,
} from '../../../store/actions/actions';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FileDownloadOutlined } from '@mui/icons-material';
import { Button, CircularProgress, Grid } from '@mui/material';
import { toastNotification } from '../../../utils/toastNotification';
import APIClient from '../../../services/ApiClient';
import { saveAs } from 'file-saver';
import MainCard from '../../../utils/MainCard';
import { InternFilter } from './Filters/Intern';
import SubCard from '../../../utils/SubCard';
import { StatsChart } from './Stats';
import { Applications } from './Applications';

export const ApplicationsReports = ({ startDate, endDate }) => {
  const applicationsByMunicipalityResponse = useSelector(({ reports }) => reports.applicationsByMunicipality);
  // const applicationsByStatusResponse = useSelector(({ reports }) => reports.applicationsByStatus);
  const applicationsByBusinessResponse = useSelector(({ reports }) => reports.applicationsByBusiness);
  const applicationsByJobResponse = useSelector(({ reports }) => reports.applicationsByJob);
  const applicationsByGenderResponse = useSelector(({ reports }) => reports.applicationsByGender);
  const applicationsByAgeResponse = useSelector(({ reports }) => reports.applicationsByAge);
  // const applicationsByEthnicityResponse = useSelector(({ reports }) => reports.applicationsByEthnicity);
  const applicationsByHealthConditionResponse = useSelector(({ reports }) => reports.applicationsByHealthCondition);
  const applicationsByCategoryResponse = useSelector(({ reports }) => reports.applicationsByCategories);

  const [loadingButton, setLoadingButton] = useState(false);
  const [municipalityChips, setMunicipalityChips] = useState([]);
  const [genderChips, setGenderChips] = useState([]);
  // const [ethnicityChips, setEthnicityChips] = useState([]);
  const [healthConditionChips, setHealthConditionChips] = useState([]);
  const [skillChips, setSkillChips] = useState([]);
  const [categoryChips, setCategoryChips] = useState([]);
  const [selectedYear, setSelectedYear] = useState('choose');

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (startDate || endDate) {
      let payload = { startDate: startDate ? startDate : undefined, endDate: endDate ? endDate : undefined };
      if (skillChips?.length) payload['skills'] = skillChips.map((skill) => skill._id);
      if (categoryChips?.length) payload['categories'] = categoryChips.map((cat) => cat._id);
      if (municipalityChips?.length) payload['municipalities'] = municipalityChips.map((mun) => mun._id);
      if (genderChips?.length) payload['genders'] = genderChips.map((e) => e._id);
      if (selectedYear !== 'choose') payload['birthYear'] = String(selectedYear);
      // if (ethnicityChips?.length) payload['ethnicities'] = ethnicityChips.map((e) => e._id);
      // if (healthConditionChips?.length) payload['healthConditions'] = healthConditionChips.map((e) => e._id);
      dispatch(applicationsByMunicipality(payload));
      // dispatch(applicationsByStatus(payload));
      dispatch(applicationsByBusiness(payload));
      dispatch(applicationsByJob(payload));
      dispatch(applicationsByGender(payload));
      dispatch(applicationsByAge(payload));
      // dispatch(applicationsByEthnicity(payload));
      dispatch(applicationsByHealthCondition(payload));
      dispatch(applicationsByCategory(payload));
    }
  }, [genderChips, healthConditionChips, skillChips, categoryChips, selectedYear, municipalityChips]); //municipalityChips, ethnicityChips

  const onDocumentDownload = async (event) => {
    setLoadingButton(true);
    event.preventDefault();
    let payload = {};
    if (endDate) payload['endDate'] = endDate;
    if (startDate) payload['startDate'] = startDate;
    if (skillChips?.length) payload['skills'] = skillChips.map((skill) => skill._id);
    if (categoryChips?.length) payload['categories'] = categoryChips.map((cat) => cat._id);
    if (municipalityChips?.length) payload['municipalities'] = municipalityChips.map((mun) => mun._id);
    if (genderChips?.length) payload['genders'] = genderChips.map((e) => e._id);
    if (selectedYear !== 'choose') payload['birthYear'] = String(selectedYear);
    // if (ethnicityChips?.length) payload['ethnicities'] = ethnicityChips.map((e) => e._id);
    // if (healthConditionChips?.length) payload['healthConditions'] = healthConditionChips.map((e) => e._id);
    await APIClient.post(`/reports/applications/export`, payload, {
      responseType: 'blob',
    })
      .then((res) => {
        setLoadingButton(false);
        if (res.data) {
          if (res.headers['content-type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            saveAs(res.data, 'Applications_Stats.csv');
          }
        } else {
          return toastNotification('error', 'Something went wrong!');
        }
      })
      .catch((err) => {
        setLoadingButton(false);
        return toastNotification('error', 'Something went wrong!');
      });
  };

  if (
    applicationsByMunicipalityResponse.loading ||
    // applicationsByStatusResponse.loading ||
    applicationsByBusinessResponse.loading ||
    applicationsByJobResponse.loading ||
    applicationsByGenderResponse.loading ||
    applicationsByAgeResponse.loading ||
    // applicationsByEthnicityResponse.loading ||
    applicationsByHealthConditionResponse.loading ||
    applicationsByCategoryResponse.loading
  ) {
    return <div class="Stats-loader">Loading...</div>;
  }
  return (
    <>
      {/* <Applications /> */}
      <MainCard title={t('generalStatistics')} sx={{ color: '#01486B', fontFamily: 'Mark-Bold !important' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <InternFilter
                  categoryChips={categoryChips}
                  skillChips={skillChips}
                  municipalityChips={municipalityChips}
                  genderChips={genderChips}
                  // ethnicityChips={ethnicityChips}
                  healthConditionChips={healthConditionChips}
                  setCategoryChips={setCategoryChips}
                  setSkillChips={setSkillChips}
                  setMunicipalityChips={setMunicipalityChips}
                  setGenderChips={setGenderChips}
                  // setEthnicityChips={setEthnicityChips}
                  setHealthConditionChips={setHealthConditionChips}
                  selectedYear={selectedYear}
                  setSelectedYear={setSelectedYear}
                />
              </Grid>
              <Grid item xs={12}>
                <SubCard
                  title={t('charts')}
                  sx={{ color: '#01486B', fontFamily: 'Mark-Bold !important' }}
                  secondary={
                    <Button
                      variant="contained"
                      disabled={loadingButton === true ? true : false}
                      sx={{
                        backgroundColor: '#01486B !important',
                        '&:hover': { backgroundColor: '#012b40 !important' },
                        width: '160px',
                        fontFamily: 'Mark-Regular',
                        fontSize: '14px',
                        textTransform: 'none !important',
                      }}
                      onClick={(e) => {
                        onDocumentDownload(e);
                      }}
                    >
                      {loadingButton ? (
                        <>
                          <CircularProgress size={24} style={{ color: '#fff' }} />
                        </>
                      ) : (
                        <>
                          <FileDownloadOutlined /> {t('exportExcel')}
                        </>
                      )}
                    </Button>
                  }
                >
                  <Grid container spacing={3}>
                    <StatsChart
                      response={applicationsByMunicipalityResponse}
                      label={t('applicationsByMunicipality')}
                      data={
                        applicationsByMunicipalityResponse?.data?.applications
                          ? applicationsByMunicipalityResponse.data.applications
                          : []
                      }
                      chart={'Bar'}
                    />
                    {/* <StatsChart
                      response={applicationsByStatusResponse}
                      label={t('applicationsByStatus')}
                      data={
                        applicationsByStatusResponse?.data?.applications
                          ? applicationsByStatusResponse.data.applications
                          : []
                      }
                      chart={'Bar'}
                    /> */}
                    <StatsChart
                      response={applicationsByBusinessResponse}
                      label={t('applicationsByBusiness')}
                      data={
                        applicationsByBusinessResponse?.data?.applications
                          ? applicationsByBusinessResponse.data.applications
                          : []
                      }
                      chart={'Bar'}
                    />
                    <StatsChart
                      response={applicationsByGenderResponse}
                      label={t('applicationsByGender')}
                      data={
                        applicationsByGenderResponse?.data?.applications
                          ? applicationsByGenderResponse.data.applications
                          : []
                      }
                      chart={'Pie'}
                    />
                    <StatsChart
                      response={applicationsByAgeResponse}
                      label={t('applicationsByAge')}
                      data={
                        applicationsByAgeResponse?.data?.applications ? applicationsByAgeResponse.data.applications : []
                      }
                      chart={'Bar'}
                    />
                    {/* <StatsChart
                      response={applicationsByEthnicityResponse}
                      label={t('applicationsByEthnicity')}
                      data={
                        applicationsByEthnicityResponse?.data?.applications
                          ? applicationsByEthnicityResponse.data.applications
                          : []
                      }
                      chart={'Bar'}
                    /> */}
                    <StatsChart
                      response={applicationsByHealthConditionResponse}
                      label={t('applicationsByHealthCondition')}
                      data={
                        applicationsByHealthConditionResponse?.data?.applications
                          ? applicationsByHealthConditionResponse.data.applications
                          : []
                      }
                      chart={'Bar'}
                    />
                    <StatsChart
                      response={applicationsByJobResponse}
                      label={t('applicationsByJob')}
                      data={
                        applicationsByJobResponse?.data?.applications ? applicationsByJobResponse.data.applications : []
                      }
                      chart={'Bar'}
                    />
                    <StatsChart
                      response={applicationsByCategoryResponse}
                      label={t('applicationsByCategory')}
                      data={
                        applicationsByCategoryResponse?.data?.applications
                          ? applicationsByCategoryResponse.data.applications
                          : []
                      }
                      chart={'Bar'}
                    />
                  </Grid>
                </SubCard>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MainCard>
    </>
  );
};
